import { trackBranch } from "../../services/orderTrackService";
import useTrackingResource from "./useTrackingResource";

const EMPTY = {};

const useBranch = (branchSwitch) => {
  const branch = useTrackingResource(trackBranch, branchSwitch, EMPTY);
  return { branch: branch ?? EMPTY };
};

export default useBranch;